import { defineStore } from 'pinia';
import axiosInstance from '@/plugins/axios';

const BASE = '/api/access/people';

/** The users page. A slower answer to an older search never replaces a newer one. */
export const useUsersStore = defineStore('users', {
    state: () => ({
        rows: [],
        meta: { page: 1, pages: 1, total: 0, accounts: null, devices: null },
        loading: false,
        error: null,
    }),

    actions: {
        async fetch({ kind, search, page }) {
            const ticket = (this._ticket = (this._ticket ?? 0) + 1);
            this.loading = true;
            this.error = null;
            try {
                const { data } = await axiosInstance.get(BASE, { params: { kind, page, ...(search ? { search } : {}) } });
                if (ticket !== this._ticket) return;
                this.rows = data.data;
                this.meta = data.meta;
            } catch (error) {
                if (ticket !== this._ticket) return;
                this.rows = [];
                this.error = error?.response?.status === 403
                    ? 'Only a super-admin can see the users.'
                    : 'The users could not be loaded.';
            } finally {
                if (ticket === this._ticket) this.loading = false;
            }
        },

        async update(user, fields) {
            const { data } = await axiosInstance.patch(`${BASE}/${user.id}`, fields);
            const at = this.rows.findIndex((row) => row.id === user.id);
            if (at >= 0) this.rows[at] = data.data;
            return data.data;
        },

        sendPasswordReset(user) {
            return axiosInstance.post(`${BASE}/${user.id}/password-reset`);
        },
    },
});
